import { defineStore } from 'pinia';

import type { AllStateType } from '@/types/stores/notificationsSocket';

export const useNotificationsStore = defineStore('notifications', {
  state: (): AllStateType => ({
    notificationsNumber: 0,
    systemNotifications: false,
    pushNotifications: false,
    audioNotification: '',
    pushNotificationEvents: [],
    systemNotificationEvents: [],
    playNotificationAudio: false,
    isAssignee: true,
    // socket connection data
    socketConnection: false,
    connectionError: null,
    reconnectionPopup: false,
  }),
  getters: {},
  actions: {
    increaseNotificationsNumber(): void {
      ++this.notificationsNumber;
    },
    setNotificationsNumber(value: number): void {
      this.notificationsNumber = value;
    },
    setSystemNotifications(value: boolean): void {
      this.systemNotifications = value;
    },
    setPushNotifications(value: boolean): void {
      this.pushNotifications = value;
    },
    setAudioNotification(value: string): void {
      this.audioNotification = value;
    },
    setPushNotificationEvents(value: string[]): void {
      this.pushNotificationEvents = value;
    },
    setSystemNotificationEvents(value: string[]): void {
      this.systemNotificationEvents = value;
    },
    setPlayNotificationAudio(value: boolean): void {
      this.playNotificationAudio = value;
    },
    setIsAssignee(value: boolean): void {
      this.isAssignee = value;
    },
    // ===================================== SOCKET CONNECTION METHODS =====================================
    /**
     * Toggle the socket connection status, this method can be used to manually trigger a reconnection attempt when the connection is lost, and it can also be used for testing purposes to simulate connection loss and recovery scenarios in the UI
     */
    toggleSocketConnection(): void {
      this.socketConnection = !this.socketConnection;
    },
    /**
     * Save the socket connection error message to the store, this method is called when the socket connection encounters an error and reaches the maximum number of reconnection attempts, it allows the UI to display a meaningful error message to the user in the reconnection popup, and it can also be used for debugging purposes to log or analyze connection issues
     */
    saveSocketError(error: string): void {
      this.connectionError = error;
    },
    /**
     * Toggle the visibility of the reconnection popup, this method is called when the socket connection encounters an error and reaches the maximum number of reconnection attempts to show the popup to the user, and it can also be used to hide the popup when the user acknowledges the error or when a new connection attempt is made
     */
    toggleSocketReconnectionPopup(): void {
      this.reconnectionPopup = !this.reconnectionPopup;
    },
  },
});
